import { subscribe } from '../auth'

const subscribeUser = (donor, recaptchaToken, extraSegments, extraSegmentIds) => {
  return subscribe(donor, recaptchaToken, extraSegments, extraSegmentIds)
}

export default {
  subscribeUser
}
